<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-menu-button auto-hide="false" data-test="sidemenuButton"></ion-menu-button>
        </ion-buttons>
        <ion-title data-test="title">Access Denied</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list>
        <ion-item>
            <ion-label class="ion-text-wrap">
                <span class="line1">Your Account Expiration Date</span><br />
                <span class="line2">{{accessDenied.expirationDate |
                    myTimestamp : 'EEEE, MMMM do yyyy, hh:mm:ss a'}}</span>
            </ion-label>
        </ion-item>
        <ion-item>
            <ion-label class="ion-text-wrap">
                <span class="line1">Your Account Number</span><br />
                <span class="line2">{{accessDenied.accountNumber}}</span>
            </ion-label>
        </ion-item>
        <ion-item>
            <ion-label class="ion-text-wrap">
                <span class="line1">Your Current Package</span><br />
                <span class="line2">{{accessDenied.packageName}}</span>
            </ion-label>
        </ion-item>
        <ion-item>
            <ion-label class="ion-text-wrap">
                <span class="line1">Our Phone Number</span><br />
                <span class="line2">{{accessDenied.phoneNumber}}</span>
            </ion-label>
        </ion-item>
        <ion-item>
            <ion-label class="ion-text-wrap">
                <span class="line1">Office Hours</span><br />
                <span class="line2">{{accessDenied.companyHours}}</span>
            </ion-label>
        </ion-item>
        <ion-item>
            <ion-label class="ion-text-wrap">
                <span class="line1">Visit our website to make a payment</span><br />
                <span class="line2" [innerHTML]="accessDenied.website"></span>
            </ion-label>
        </ion-item>
        <ion-item>
            <ion-label class="ion-text-wrap">
                <span class="line1">Your Action Item</span><br />
                <span class="line2" [innerHTML]="accessDenied.callToAction"></span>
            </ion-label>
        </ion-item>
    </ion-list>
</ion-content>